<template>
    <section class="inline nogap">
        <div class="grid fixed fixed-max-sm gap-3 xs-grid-cols-1 md-grid-cols-3">
            <div class="inline large flex corner bg-transparent">
                <div class="grid xs-grid-cols-1">
                    <h2 class="f2 text-bold">Market Overview for September 2023</h2>
                    <div class="text-brand f3 text-bold"><i class="icon-pin"></i> {{glb.geo && glb.geo.city ? `${glb.geo.city}, ${glb.geo.state}` : ''}}</div>
                </div>
            </div>
            <div class="inline large flex corner bg-default center">
                <div class="grid xs-grid-cols-1 center text-center">
                    <div class="circle main"><i  class="icon-house"></i></div>
                    <div class="text-bold f3">Houses</div>
                    <div>
                        <div class="text-bold">{{snapshot.singlePriceMedian}} Median List Price</div>
                        <div class="f6">{{snapshot.singleDesc}}</div>
                    </div>
                    <div class="flex small ">
                        <div>
                            <b class="f3 text-bold">{{snapshot.singleSizeMedian}}</b>
                            <div class="f7">Square Feet</div>
                        </div>
                        <div>
                            <b class="f3 text-bold">{{snapshot.singlePricePerSqftMedian}}</b>
                            <div class="f7">$ / Sqft</div>
                        </div>
                        <div>
                            <b class="f3 text-bold">{{snapshot.singleDom}}</b>
                            <div class="f7">Days on Market</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="inline large flex corner bg-default center">
                <div class="grid xs-grid-cols-1 center text-center">
                    <div class="circle main"><i  class="icon-property-condo"></i></div>
                    <div class="text-bold f3">Condos / Townhomes</div>
                    <div>
                        <div class="text-bold">{{snapshot.condoPriceMedian}} Median List Price</div>
                        <div class="f6">{{snapshot.condoDesc}}</div>
                    </div>
                    <div class="flex small ">
                        <div>
                            <b class="f3 text-bold">{{snapshot.condoSizeMedian}}</b>
                            <div class="f7">Square Feet</div>
                        </div>
                        <div>
                            <b class="f3 text-bold">{{snapshot.condoPricePerSqftMedian}}</b>
                            <div class="f7">$ / Sqft</div>
                        </div>
                        <div>
                            <b class="f3 text-bold">{{snapshot.condoDom}}</b>
                            <div class="f7">Days on Market</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script src="./mvt-snapshot.js"></script>